import {
  Grid,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useMemo } from "react";
import ValuoTable from "../ValuoTable";

const DashboardSuperAdmin = ({ user, evaluations }) => {
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  const evaluationsFiltered = useMemo(() => {
    return (
      (evaluations || []).filter((item) => {
        if (item.phase !== "3") return false;

        const name = item.collaborator?.name || "";
        const matchesSearch = searchTerm
          ? name.toLowerCase().includes(searchTerm.trim().toLowerCase())
          : true;

        const year = item.data_partner?.anno || item.year;
        const matchesYear = selectedYear ? year === selectedYear : true;

        return matchesSearch && matchesYear;
      }) || []
    );
  }, [evaluations, searchTerm, selectedYear]);

  const anniDisponibili = [
    ...new Set(evaluations?.map((el) => el.year || null)),
  ];

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  return (
    <>
      <Grid
        item
        xs={11}
        md={9}
        justifyContent="center"
        alignItems="flex-start"
        sx={{ width: "100%", paddingY: "40px" }}
      >
        <Typography sx={{ mb: 2, fontSize: 22, fontWeight: 600 }}>
          Lista valutazioni
        </Typography>

        <Grid
          container
          spacing={2}
          sx={{
            marginTop: "20px",
            marginBottom: "30px",
            justifyContent: "flex-start",
          }}
        >
          {/* SEARCHBAR */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <TextField
              placeholder="Ricerca per professionista"
              fullWidth
              variant="outlined"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                endAdornment: searchTerm && (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="clear search"
                      onClick={handleClearSearch}
                      edge="end"
                      sx={{
                        color: "#1b2838",
                        "&:hover": { backgroundColor: "transparent" },
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "grey", borderWidth: "1px" },
                  "&:hover fieldset": {
                    borderColor: "#1b2838",
                    borderWidth: "1px",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#1b2838",
                    borderWidth: "1px",
                  },
                },
                "& input::placeholder": { fontSize: "14px" },
              }}
            />
          </Grid>

          {/* SELECT ANNO */}
          <Grid
            item
            xs={12}
            md={3}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Select
              fullWidth
              displayEmpty
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              renderValue={(selected) => {
                if (selected === "")
                  return (
                    <span style={{ color: "#9d9d9e" }}>Seleziona anno</span>
                  );
                return (
                  <span style={{ color: "#1b2838", fontWeight: 500 }}>
                    {selected}
                  </span>
                );
              }}
              sx={{
                height: "100%",
                "& .MuiSelect-select": {
                  color: "#1b2838 !important",
                  py: 1.2,
                },
                "& .MuiSvgIcon-root": { color: "#9d9d9eff" },
              }}
            >
              <MenuItem value="">
                <span className="color-blue-dark">Seleziona anno</span>
              </MenuItem>
              {anniDisponibili.map((anno) => (
                <MenuItem key={anno} value={anno}>
                  <Typography sx={{ color: "#1b2838" }}>{anno}</Typography>
                </MenuItem>
              ))}
            </Select>
          </Grid>

          {/* SELECT TEAM */}
        </Grid>

        {evaluationsFiltered && evaluationsFiltered.length > 0 ? (
          <ValuoTable evaluations={evaluationsFiltered} user={user} />
        ) : (
          <Typography sx={{ mt: 4, fontSize: 18, color: "#666" }}>
            Nessuna valutazione disponibile
          </Typography>
        )}
      </Grid>

      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress sx={{ color: "#1b2838" }} />
        </div>
      )}
    </>
  );
};

export default DashboardSuperAdmin;
